import { useMemo } from 'react';

import { Box } from '@mui/material';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useIframeCommunication } from 'hooks/useIframeCommunication';
import { buildThemeParams } from 'microfrontends/config/theme';
import { API_URLS } from 'utils/apiUrlBuilder';

interface CommunityProfileProps {
  userId: string;
  pageName: string;
  formId: string;
}
const DashboardsCommunityProfile = ({ userId, pageName, formId }: CommunityProfileProps) => {
  const theme = useThemeContext();

  const themeParams = useMemo(() => buildThemeParams(theme), [theme]);

  const getToken = () => {
    try {
      const token = localStorage.getItem('AUTH_TOKEN');
      if (!token) {
        console.warn('Token not found in localStorage');
        return '';
      }
      return token;
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

  const getOrganizationUuid = () => {
    try {
      const orgUuid = localStorage.getItem('x-organization-uuid');
      if (!orgUuid) {
        console.warn('Organization UUID not found in localStorage');
        return '';
      }
      return orgUuid;
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

  const baseUrl = useMemo(() => {
    const token = getToken();
    const orgUuid = getOrganizationUuid();
    return `${API_URLS.DASHBOARDS}/community-profile/${pageName}/${formId}/${userId}?token=${token}&organization_uuid=${orgUuid}&pageName=${pageName}`;
  }, [userId, pageName, formId]);

  const iframeUrl = useMemo(() => `${baseUrl}&${themeParams}`, [baseUrl, themeParams]);

  const { iframeRef } = useIframeCommunication(iframeUrl);

  console.log('[DashboardsCommunityProfile] iframeUrl', iframeUrl);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          minHeight: 0,
          overflow: 'auto',
          border: 'none',
          display: 'block',
        }}
        width="100%"
        scrolling="yes"
        title="Dashboard Community Profile - NextJS"
      />
    </Box>
  );
};

export default DashboardsCommunityProfile;
